import { useQuery } from '@tanstack/react-query';

import axios from '../../common/axios';
import { ENTITY } from './entity';

export const useCheckUsernameAvailableQuery = (username: string) => {
  return useQuery<{ available: boolean }>({
    queryKey: ['username-available', username],
    queryFn: async () => {
      const { data } = await axios.get<{ available: boolean }>(`${ENTITY}/username-available`, {
        params: { username },
      });
      return data;
    },
    enabled: username.length > 0,
    staleTime: 5_000,
  });
};
